import React, { FC, useCallback } from 'react';
import classNames from 'classnames';
import { useTranslationAPI } from '../../../translations';
import { codes } from '../../../../data/translations/codes';
import { useListSidebarProvider } from './useListSidebarProvider';
import classes from './styles/listSidebarHeaderCloseButton.module.scss';
import { AngleRightLarge } from '../../../../components/Icons/AngleRightLarge';

export const ListSidebarHeaderCloseButton: FC<{ disabled?: boolean }> = ({ disabled }) => {
	const { translate } = useTranslationAPI();
	const { setIsExpanded, isCloseButtonDisabled } = useListSidebarProvider();
	const componentClasses = classNames(classes.listSidebarHeaderCloseButton, {
		[classes.listSidebarHeaderCloseButton_disabled]: isCloseButtonDisabled,
	});
	const handleCloseButtonClick = useCallback(() => {
		if (isCloseButtonDisabled) {
			return;
		}

		setIsExpanded(false);
	}, [isCloseButtonDisabled, setIsExpanded]);

	return (
		<button
			className={componentClasses}
			type='button'
			onClick={handleCloseButtonClick}
			disabled={disabled}
		>
			<AngleRightLarge
				className={classes.icon}
				height='16px'
				width='16px'
			/>
			{translate(codes.common.close)}
		</button>
	);
};
